import { Navigate, useParams, useSearchParams, type PathParam } from 'react-router-dom';
import {
    GAME_ASSETS_REDIRECT_PATH,
    KIND_PARAM,
    STUDIO_REDIRECT_PATH,
    gameAssetsRoute,
    gamesRoute,
} from '../domain/routes.js';

/** `/studios/:key` — there is no per-studio page; its games are the Games page filtered to it. */
export const StudioRedirect = () => {
    const { key = '' } = useParams<PathParam<typeof STUDIO_REDIRECT_PATH>>();
    return <Navigate to={gamesRoute(key || null)} replace />;
};

/** `/games/:studio/:id/assets` from before assets became the editor's last section: keeps old links working. */
export const GameAssetsRedirect = () => {
    const { studio = '', id = '' } = useParams<PathParam<typeof GAME_ASSETS_REDIRECT_PATH>>();
    const [searchParams] = useSearchParams();
    return <Navigate to={gameAssetsRoute(studio, id, searchParams.get(KIND_PARAM))} replace />;
};
